import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Input } from "./ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Address input backed by Google Places API (New) via our backend proxy.
// Shows a suggestions dropdown; degrades to a plain field if the API is down.
export const AddressInput = ({ value, onChange, onPlace, placeholder, className, testid }) => {
  const [sugs, setSugs] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const skip = useRef(false);
  const focused = useRef(false);

  useEffect(() => {
    if (skip.current) { skip.current = false; return; }
    const q = (value || "").trim();
    if (q.length < 3) { setSugs([]); setOpen(false); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/places/autocomplete`, { params: { q } });
        const list = data.suggestions || [];
        setSugs(list);
        setOpen(list.length > 0 && focused.current); // only pop open while the field is focused
      } catch { setSugs([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [value]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const pick = (s) => { skip.current = true; onChange(s.description); onPlace?.(s.place_id); setOpen(false); setSugs([]); };

  return (
    <div ref={boxRef} className="relative">
      <Input
        data-testid={testid}
        value={value}
        onChange={(e) => { onChange(e.target.value); onPlace?.(null); }}
        onFocus={() => { focused.current = true; if (sugs.length) setOpen(true); }}
        onBlur={() => { focused.current = false; }}
        placeholder={placeholder}
        className={className}
        autoComplete="off"
      />
      {open && (
        <ul data-testid={`${testid}-suggestions`}
          className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border-2 border-ink max-h-56 overflow-auto shadow-[6px_6px_0_0_rgba(10,10,10,0.15)]">
          {sugs.map((s, i) => (
            <li key={s.place_id || i} data-testid={`${testid}-sug-${i}`}
              onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              className="px-3 py-2.5 text-sm text-ink hover:bg-sun cursor-pointer border-b border-ink/10 last:border-0">
              {s.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
